<!-- 热力图指示器 -->
<template>
  <div class="thermodynamic_scale">
    <div class="title" v-if="type">{{ name }}</div>
    <div class="scale">
      <div class="bar" :style="style"></div>
      <div class="label">
        <div class="item" v-for="v in [100, 50, 0]" :key="v">{{ v }}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import { THERMODYNAMIC_COLOR } from '../constants';
export default {
  name: 'ThermodynamicScale',
  props: {
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    name() {
      let self = this;
      let name = { thermodynamic: '收割热力', progression: '收割进度' }[self.type];
      return name;
    },
    style() {
      const colors = THERMODYNAMIC_COLOR.join(',');
      let style = {
        background: `linear-gradient(to top, ${colors})`,
      };
      console.log(style);
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
.thermodynamic_scale {
  padding: vh(10) vw(15) vh(15);
  background: rgba(4, 28, 16, 0.45);
  transform: skew(4deg);
  font-size: vw(12);
  color: #fff;
  border-radius: vw(3);
  pointer-events: none;
  .title {
    margin-bottom: vh(20);
  }
  .scale {
    position: relative;
    display: flex;
    .bar {
      width: vw(10);
      height: vh(130);
    }
    .label {
      margin: -0.5em 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-left: vw(10);
      .item {
        line-height: 1;
        &:nth-child(1) {
          top: vh(0);
        }
        &:nth-child(2) {
          top: vh(50);
        }
        &:nth-child(3) {
          top: vh(100);
        }
      }
    }
  }
}
</style>
